export default __webpack_public_path__ + "static/media/Interactive Map.87eb8a15.svg";